import React, { useMemo } from 'react';
import type { Options } from 'react-joyride';
import { defaultCompanion } from 'components/Companion';

import {
  UserGuidedTour,
  type UserGuidedTourStepDefinition,
} from 'components/tours/UserGuidedTour';

const QUESTION_FLOW_CONTROLS_TOUR_KEY = 'question-flow-controls-v1';

const STEP_DEFINITIONS: UserGuidedTourStepDefinition[] = [
  {
    selector: '[data-tour-id="question-flow-control-companion"]',
    title: defaultCompanion.displayName,
    content: 'Ask for clarification or a summary of the current material.',
  },
  {
    selector: '[data-tour-id="question-flow-control-narration"]',
    title: 'Narration',
    content: 'Turn question audio on or off when narration is available.',
  },
  {
    selector: '[data-tour-id="question-flow-control-note"]',
    title: 'Create Note',
    content: 'Save a note tied to this question and module so you can revisit it later.',
  },
  {
    selector: '[data-tour-id="question-flow-control-feedback"]',
    title: 'Feedback',
    content: 'Report a problem or confusion about the current question.',
  },
];

const JOYRIDE_OPTIONS: Partial<Options> = {
  skipScroll: true,
};

type QuestionFlowControlsTourProps = {
  flowName: string;
  isActive: boolean;
  launchToken: number;
  questionId: number | null;
};

export const QuestionFlowControlsTour: React.FC<QuestionFlowControlsTourProps> = ({
  flowName,
  isActive,
  launchToken,
  questionId,
}) => {
  const analyticsMetadata = useMemo(
    () => ({
      flow_name: flowName,
    }),
    [flowName],
  );

  return (
    <UserGuidedTour
      analyticsMetadata={analyticsMetadata}
      analyticsScreenName={flowName}
      analyticsSurface="question_flow"
      autoStartKey={questionId}
      defaultPlacement="left"
      isActive={isActive}
      joyrideOptions={JOYRIDE_OPTIONS}
      launchToken={launchToken}
      scrollToFirstStep={false}
      stepDefinitions={STEP_DEFINITIONS}
      tourKey={QUESTION_FLOW_CONTROLS_TOUR_KEY}
    />
  );
};
